import { navigate } from 'gatsby';
import React, { FC } from 'react';
import styled from 'styled-components';

import BasicText from '@ui/atoms/BasicText';
import FlexColumn from '@ui/atoms/FlexColumn';
import SubheadingText from '@ui/atoms/SubheadingText';
import TextLink from '@ui/atoms/TextLink';

import CenteredGridItem from '@ui/molecules/CenteredGridItem';

import spaced from '@ui/styled/Spaced';

import { IFlowStepProps } from '@folx-types/flow-steps';

import theme from '@theme/FolxTheme';

export interface IMemberAlreadySubscribedStepPageContent {
	header: string;
	body: string;
	folxLink: string;
	folxHref: string;
	helpLink: string;
	helpHref: string;
}

interface IMemberAlreadySubscribedStep extends IFlowStepProps {
	pageContent: IMemberAlreadySubscribedStepPageContent;
}

const SpacedGridItem = spaced(CenteredGridItem);

const MemberAlreadySubscribedStep: FC<IMemberAlreadySubscribedStep> = ({ pageContent }) => {
	const { header, body, folxLink, folxHref, helpLink, helpHref } = pageContent;

	return (
		<SpacedGridItem marginBottom="xxl">
			<FlexColumn gap="sm">
				<SubheadingText>{header}</SubheadingText>
				<BasicText>{body}</BasicText>
				<FlexColumn gap="xssm">
					<TextLink label={folxLink} href={folxHref} />
					<TextLink label={helpLink} href={helpHref} newTab />
				</FlexColumn>
			</FlexColumn>
		</SpacedGridItem>
	);
};

export default MemberAlreadySubscribedStep;
